import React from 'react';
import { Container } from './styles';
import { useNavigation } from '@react-navigation/native';
import { Image } from 'react-native';
import back from '../../Assets/Images/back.svg';
import { useSelector } from 'react-redux';

const BackArrow = () => {
  const { store } = useSelector(state => state.general);
  const navigation = useNavigation();
  return (
    <Container activeOpacity={0.7} onPress={() => navigation.goBack()}>
      <Image
        style={{ width: 20, height: 20, tintColor: store.theme.primary }}
        resizeMode="contain"
        source={back}
      />
    </Container>
  );
};

export default BackArrow;
